__turbopack_context__.v({
  "badge": "AddOnCategoryBadges-module-scss-module__mIC86G__badge",
  "badge--artikelen": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--artikelen",
  "badge--bbo": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--bbo",
  "badge--default": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--default",
  "badge--engineering": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--engineering",
  "badge--financieel": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--financieel",
  "badge--inkoop": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--inkoop",
  "badge--meldingen": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--meldingen",
  "badge--planning": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--planning",
  "badge--productie": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--productie",
  "badge--rapportage": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--rapportage",
  "badge--relaties": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--relaties",
  "badge--systeem": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--systeem",
  "badge--uren": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--uren",
  "badge--verkoop": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--verkoop",
  "badge--voorraad": "AddOnCategoryBadges-module-scss-module__mIC86G__badge--voorraad",
  "badges": "AddOnCategoryBadges-module-scss-module__mIC86G__badges",
});
